import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { IApproveBankProofRequest, IApproveBankProofResponse } from '../models/bank-proof.model';
import { approveBankProofFailure, approveBankProofRequest, approveBankProofResponse } from '../actions/bank-proofs.actions';
import { IApproveBankProofDocumentRequest, IApproveBankProofDocumentResponse } from '../models/bank-proof-documents.model';
import { approveBankProofDocumentFailure, approveBankProofDocumentRequest, approveBankProofDocumentResponse } from '../actions/bank-proof-documents.actions';
import { ApproveBankProofState } from './approve-bankproof.reducer';
import { IAddBankRequest, IAddBankResponse } from '../models/employee-bank-detail.model';
import { addBank, addBankFailure, addBankSuccess } from '../actions/add-bank.actions';

export const addBankFeatureKey = 'addBank';

export interface AddBankState {
  addBankRequest: IAddBankRequest;
  addBankSuccess: IAddBankResponse;
  addBankFailure: IGenericError<ErrorResponse>;
}

export const initialState: AddBankState = {
  addBankRequest: undefined,
  addBankSuccess: undefined,
  addBankFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(addBank, (state, action) => ({
    ...state,
    addBankRequest: action.request.body
  })),
  on(addBankSuccess, (state, action) => ({
    ...state,
    addBankSuccess: action.response
  })),
  on(addBankFailure, (state, action) => ({
    ...state,
    addBankFailure: action.error
  }))
);

export const getAddBankRequest = (state: AddBankState) => state.addBankRequest;
export const getAddBankSuccess = (state: AddBankState) => state.addBankSuccess;
export const getAddBankFailure = (state: AddBankState) => state.addBankFailure;
